// extracted by mini-css-extract-plugin
module.exports = {"bottom-action-bar":"bottomActionBar_bottom-action-bar__2bY53","total-amount":"bottomActionBar_total-amount__2nkx3","bottom-action-btn":"bottomActionBar_bottom-action-btn__2kKot"};